import React from 'react';
import _ from 'lodash';

import {
  QueryOrdersFilterInput,
  useExportNetSuiteXmlRequestsLazyQuery,
  useNetSuiteActivity_SoapRequestTabLazyQuery
} from 'generated/graphql';
import {
  listQueryUtil,
  protectedFileUtil
} from 'iron-forge-react-modules';

import { DateTime } from 'luxon';
import * as types from './types';



const useListQuery = listQueryUtil.genUseListQuery<types.IColumnId>();



export interface IRow {
  id: string;
  orderNumber: string;
  orderDate: DateTime;

  customerEmail: string;

  storeName: string;
  departmentId: string;
  inventoryLocationId: string;
  subsidiaryId: string;
  taxItemName: string;
}

export interface IData {
  rows: IRow[];
}

export function useQuery() {
  return useListQuery({
    useLazyQuery: useNetSuiteActivity_SoapRequestTabLazyQuery,
    gqlResultData2GqlPageInfo: gql => gql?.orders.pageInfo,
    clientColumn2GqlSortField: {},
    defaultFilterArgs: {},
    initQuerySort: {
      columnId: 'orderDate',
      direction: 'descending'
    },
    genFilter2GqlFilter: () => __filter2GqlFilter,
    gqlResultData2TupleData: (gql): IData => ({
      rows: _.map(gql.data?.orders.nodes ?? [], (order): IRow => ({
        id: order.id,
        orderNumber: order.orderNumber,
        orderDate: DateTime.fromISO(order.orderDate),
        customerEmail: order.customer.email,
        storeName: order.store.name,
        departmentId: order.store.department?.name ?? '',
        inventoryLocationId: order.store.inventoryLocation?.name ?? '',
        subsidiaryId: order.store.subsidiary?.name ?? '',
        taxItemName: order.store.taxItem?.name ?? ''
      }))
    })
  });
}



function __filter2GqlFilter(): QueryOrdersFilterInput {
  return {};
}



export function useExportNetSuiteXmlRequests() {
  const [fnQuery, tuple] = useExportNetSuiteXmlRequestsLazyQuery({
  });

  const fnWrappedQuery = React.useCallback(
    async (orderIds: string[]) => {
      const result = await fnQuery({
        variables: {
          orderIds
        }
      });

      if (result.data?.exportNetSuiteXmlRequests) {
        protectedFileUtil.forceDownloadEncodedFile(result.data.exportNetSuiteXmlRequests);
      }
    },
    [fnQuery]
  );

  return React.useMemo(
    () => [
      fnWrappedQuery,
      {
        ...tuple,
        data: null
      }
    ] as const,
    [
      fnWrappedQuery,
      tuple
    ]
  );
}
